import React, { useState, useEffect } from "react";
import "./Css/CarFeatures.css";
import Header from "./Header";
import GreyArrow from "../assets/greyLeftAr.png";
import { mondayDayYearFormat, goBack, handleError } from "../CommonJquery/CommonJquery.js";
import { Button } from "@mui/material";
import { ArrowLeft, Trash2 } from "lucide-react";
import { Add_car_feature, get_car_feature, server_post_data, delete_car_feature, APL_LINK } from "../ServiceConnection/serviceconnection.js";
import Loader from "./Loader.js";
import { Modal } from "react-bootstrap";
export default function CarFeatures() {
    const [carImage, setCarImage] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [imng_link, set_imng_link] = useState("");
    const [carName, setCarName] = useState("");
    const [primaryId, setPrimaryId] = useState(null);

    const [errors, setErrors] = useState({
        carImage: false,
        carName: false
    });
    const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
    const [filteredData, setFilteredData] = useState([
    ]);
    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const isImage = file.type.startsWith("image/");
            if (!isImage) {
                alert("❌ Please upload a valid image file (JPG, PNG, etc.)");
                setCarImage(null);
                setErrors(prev => ({ ...prev, carImage: true }));
                e.target.value = "";
                return;
            }
            setCarImage(file);
            setErrors(prev => ({ ...prev, carImage: false }));
        }
    };

    const handleNameChange = (e) => {
        const name = e.target.value;
        setCarName(name);
        setErrors(prev => ({ ...prev, carName: false }));
    };
    const handleValidation = () => {
        const newErrors = {
            carImage: !carImage,
            carName: carName.trim() === ""
        };
        setErrors(newErrors);
        return !newErrors.carImage && !newErrors.carName;
    };



    const handleAddFeature = () => {
        if (handleValidation()) {
            handleSubmit();
        } else {
            //console.log("❌ Validation failed. Fix the errors.");
        }
    };

    const handleSubmit = async () => {
        setshowLoaderAdmin(true);
        let fd_from = new FormData();
        fd_from.append("name", carName);
        fd_from.append("image", carImage);

        await server_post_data(Add_car_feature, fd_from)
            .then((Response) => {
                if (Response.data.error) {
                    handleError(Response.data.message);
                } else {
                    master_data_get();
                }
                setshowLoaderAdmin(false);

            })
            .catch((error) => {
                console.log(error);
                setshowLoaderAdmin(false);
            });

    };

    useEffect(() => {
        master_data_get();
    }, []);


    const master_data_get = async () => {
        setshowLoaderAdmin(true);
        const fd = new FormData();
        await server_post_data(get_car_feature, fd)
            .then((Response) => {
                if (Response.data.error) {
                    handleError(Response.data.message);
                } else {
                    set_imng_link(APL_LINK + Response.data.message.image_link);
                    setFilteredData(Response.data.message.features);
                }
                setshowLoaderAdmin(false);
            })
            .catch((error) => {

                setshowLoaderAdmin(false);
            });
    };

    const handleDelete_feature = async (primary_id) => {
        setshowLoaderAdmin(true);
        let fd_from = new FormData();
        fd_from.append("call_id", primary_id);
        await server_post_data(delete_car_feature, fd_from)
            .then((Response) => {
                if (Response.data.error) {
                    handleError(Response.data.message);
                } else {
                    master_data_get();
                }
                setshowLoaderAdmin(false);
            })
            .catch((error) => {
                console.log(error);
                setshowLoaderAdmin(false);
            });

    };
    return (
        <div>
            <Header />
            {showLoaderAdmin && <Loader />}

            <div className="pageCntn_head">
                <div className="pageNameDiv">
                    <p>Car Features</p>
                    <img src={GreyArrow} alt="Rapid Car Leasing" />
                </div>
                <Button
                    onClick={goBack}
                    startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
                    className="Back_bttn_page"
                >
                    Back
                </Button>
            </div>
            <div className="add_img_feature_div">
                <h2>Add Car </h2>
                <div className="row">
                    <div className="col-md-4">
                        <label>
                            Upload Car Image <span style={{ color: "var(--red-bg)" }}>*</span>
                        </label>
                        <input type="file" accept="image/*" className="form-control" onChange={handleImageChange} />
                        {errors.carImage && (
                            <span style={{ color: "red", fontSize: "0.9em" }}>Please upload the car image.</span>
                        )}
                    </div>
                    <div className="col-md-4">
                        <label>
                            Car Name <span style={{ color: "var(--red-bg)" }}>*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Car Name"
                            value={carName}
                            onChange={handleNameChange}
                        />
                        {errors.carName && (
                            <span style={{ color: "red", fontSize: "12px" }}>Please enter the car name.</span>
                        )}
                    </div>
                    <div className="col">
                        <div className="add_car_feature_bttn">
                            {" "}
                            <Button onClick={handleAddFeature} >Add Car Features</Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="page_body">
                <div className="viewStaff">
                    <div className="viewGuest_table">
                        <div className="viewGuest_table_container">
                            <div className="row m-0">
                                <div className="col-md-12">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    <div className="theadStyle imgThead">
                                                        <span>Sr. No.</span>
                                                    </div>
                                                </th>
                                                <th scope="col">
                                                    <div className="theadStyle">Entry Date</div>
                                                </th>
                                                <th scope="col">
                                                    <div className="theadStyle">Image</div>
                                                </th>
                                                <th scope="col">
                                                    <div className="theadStyle">Name</div>
                                                </th>
                                                <th scope="col">
                                                    <div className="theadStyle">Action</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="tboday custum_border">
                                            {filteredData.map((option, index) => {
                                                return (
                                                    <React.Fragment>
                                                        <tr className="tableRow">
                                                            <td className="th1">
                                                                <div className="tbodyStyle guest_incenter borderLeftRadius">
                                                                    {index + 1}
                                                                </div>
                                                            </td>
                                                            <td className="th1">
                                                                <div className="tbodyStyle guest_incenter borderLeftRadius">
                                                                    {mondayDayYearFormat(option.entry_date)}
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className="tbodyStyle guest_incenter shadowOnlyBottom">
                                                                    <img
                                                                        className="car_feature_img"
                                                                        src={
                                                                            imng_link + option.image
                                                                        }
                                                                        alt="Rapid Car Leasing"
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="tbodyStyle guest_incenter shadowOnlyBottom">
                                                                    {option.name}
                                                                </div>
                                                            </td>
                                                            <td className="th2" style={{ overflow: "hidden" }}>
                                                                <div className="tbodyStyle1 guest_incenter borderRightRadius">
                                                                    <Trash2
                                                                        size={17}
                                                                        className="DELETE_ICON"
                                                                        style={{ cursor: "pointer" }}
                                                                        onClick={() => {
                                                                            setPrimaryId(option.primary_id);
                                                                            setShowDeleteModal(true);
                                                                        }}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr style={{ height: "1rem" }}></tr>
                                                    </React.Fragment>
                                                );
                                            })}
                                            {filteredData.length === 0 && (
                                                <tr>
                                                    <td colSpan={5} className="text_align_center">
                                                        No Results Found
                                                    </td>{" "}
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="confrm_ddltt">Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body className="feature_modal_body">
                    Are you sure you want to delete this feature?
                </Modal.Body>
                <Modal.Footer>
                    <div className="feature_delete_modal_btn">
                        <Button className="no_btn_feature" variant="outlined"
                            color="primary" onClick={() => setShowDeleteModal(false)}>
                            No
                        </Button>
                        <Button
                            className="yes_btn_feature"
                            variant="contained"
                            color="error"
                            onClick={() => {
                                handleDelete_feature(primaryId);
                                setShowDeleteModal(false);
                            }}
                        >
                            Yes, Delete
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

        </div>
    );
}
